import { C8Node } from "c8-platform";
import localeProvider from "csi/page/localeProvider";
import { routerStore } from "csi/state/rootStore";
import declare from "dojo/_base/declare";
import { C8RequestError } from "src/c8-platform/core/request";
import NewCustomAttribute from "src/SiteAdmin/NewCustomAttribute";
import AttributeDefinitionPopup from "./AttributeDefinitionPopup";
import AttributeDefinitionStore from "./AttributeDefinitionStore";
import { getRootRequest } from "./AttributeDefinitionValidationService";

const AttributeDefinitionController = declare(NewCustomAttribute, {
	/** @param {AttributeDefinitionStore} store */
	store: null,

	/**
	 * @override
	 * Return all attributes created in dialog
	 */
	getNewNodes(): C8Node[] {
		return this.store.resultNodes;
	},
	
	/**
	 * @override
	 * Open React dialog
	 */
	async preProcess(): Promise<void> {
		const cache = this.getCache();
		const store = this.store = new AttributeDefinitionStore(null, this.getParent(), this.getCache(), localeProvider);
		
		let request = getRootRequest(this);
		if (request) {
			request = cache.reduceNodesRequest(request);
		}
		if (request) {
			this.widget.annotateViewRequest(request);

			const res = await request.go();
			cache.cacheResponse(res);
		}
		
		this.useReactDialog(routerStore.openDialog(AttributeDefinitionPopup, {
			onClickSaveNew: ()=> {
				if (!store.validate()) {
					return;
				}
				this.repeatReactForm = true;
				this.save();
				store.resetStore();
				store.focusFirstInputField();
			},
			onClose: ()=> {
				this.onCancelReactDialog();
			}, 
			onSave: ()=> {
				if (!store.validate()) {
					return;
				}
				this.repeatReactForm = false;
				this.save();
			},
			title: this.getTitle(),
			store,
		}));
	},

	/**
	 * create new attribute
	 */
	save(): void {
		this.processReact(this.store.saveForm());
	},

	/**
	 * @override
	 * Set error from dialog
	 */
	_onPublishError(err: C8RequestError): void {
		this.store.setFormError(err);
		this.inherited(arguments);
	},
});

export = AttributeDefinitionController;
